import React, { useState } from "react";
import axios from "axios";
//import { Link } from "react-router-dom";
//const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const BASE_URL = process.env.REACT_APP_API_BASE_URL;
function Test() {
  const [activeAlbum, setActiveAlbum] = useState(null);

  async function runDataFunction() {
    try {
      await axios.get("sanctum/csrf-cookie");

      const responses = await Promise.all([
        axios.get(`${BASE_URL}galarycombine`),
      ]);

      const [galdata] = responses;

      if (galdata.data.status === 200) {
        setActiveAlbum(galdata.data.allData);
        
      } else {
        console.log("Oops!", galdata.data.validation_error);
      }
    } catch (error) {
      console.log("Error", "There were no Data found!");
    }
  }

  return (
    <div style={{ padding: "20%" }}>~~
      <button
        type="button"
        className="btn btn-primary me-3"
        onClick={runDataFunction}
        style={{
          marginTop: "0px",
          fontSize: "2rem",
          padding: "5% 10%",
        }}
      >
        Click To Run
      </button>
      <div style={{paddingTop: '3%'}}>{activeAlbum ? `${activeAlbum} Processed` : 'Yet To Process!'}</div>
    </div>
  );
}

export default Test;
